import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const useToastError = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const errorCode = searchParams.get('errorCode');

  useEffect(() => {
    if (errorCode) {
      const element = (
        <Trans
          i18nKey={`ticketSale.${errorCode}`}
          components={{ bold: <strong /> }}
        />
      );
      toast.error(element, {
        position: 'bottom-right',
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
      setSearchParams({});
    }
  }, []);

  return null;
};

export default useToastError;
